<template>
  <div>
    <el-timeline :reverse="reverse">
      <el-timeline-item
        hide-timestamp
        v-for="(activity, index) in list"
        :key="index"
        :timestamp="activity.timestamp"
        :color="index == actindex ? '#409eff' : '' "
        :size="activity.size"
        :class="{clicked:index == actindex}"
        placement="top"
        @click.native="handlePos(activity,index)"
      >{{activity}}</el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  props: ["list"],
  data() {
    return {
      reverse: false,
      actindex: null
    };
  },
  components: {},
  updated() {
    var that =this
    var _top = $(".louceng").offset().top;
    $(window).scroll(function() {
      //  获取页面卷去的间距
      var v = $(window).scrollTop() + 200;
      // 滚动条在滚动时，根据卷去的楼层项切换导航项
      for (var i = $(".left").length - 1; i >= 0; i--) {
        if (v >= $(".left").eq(i).offset().top){
          that.actindex = i;
          break;
        }
      }
    });
  },
  methods: {
    handlePos: function(e, index) {
      // 点击时间线 展示对应的相册
      var toscroll = document.getElementById(`${e}`).offsetTop;
      document.documentElement.scrollTop = toscroll - 200;
      // 选中的高亮
      this.actindex = index;
    }
  }
};
</script>

<style lang="less">
.clicked {
  .el-timeline-item__content {
    color: #409eff;
  }
}
.el-timeline-item:hover {
  cursor: pointer;
  .el-timeline-item__content {
    color: #409eff;
  }
  .el-timeline-item__node {
    background: #409eff;
  }
}
</style>
